










import Component from 'vue-class-component'
import Vue from 'vue'
import RespondecoTopBar from '@/main/respondeco-top-bar.vue'
import { Prop } from 'vue-property-decorator'
import { activeUserIsAdmin, activeUserIsOwner } from '@/shared/utils/user'
import { loggerFor } from '@/shared/utils/logger'

@Component({
  name: 'respondeco-edit-item-bar',
  components: { RespondecoTopBar },
})
export default class RespondecoEditItemBar extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly adminOnly!: boolean

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly allowPartners!: boolean

  @Prop({
    required: true,
    type: Object,
  })
  public readonly item!: {
    id: number
    organisation: {
      id: number
    }
    partners?: Array<{
      organisation: {
        id: number
      }
    }>
  }

  @Prop({
    required: true,
    type: String,
  })
  public readonly route!: string

  private logger = loggerFor('EditItemBar')

  get activeUserIsOwner() {
    let allow: boolean

    if (this.adminOnly === true) {
      allow = activeUserIsAdmin()
    } else {
      const organisationId = this.item.organisation.id

      const isOwner: boolean = organisationId ? activeUserIsOwner(organisationId) : false

      let isPartner = false

      if (this.allowPartners === true) {
        if (this.item.partners === undefined) {
          this.logger.warn('allowPartners is set to true but the item does not contain partners')
        } else {
          isPartner = this.item.partners
            .map(partner => activeUserIsOwner(partner.organisation.id))
            .reduce((a, b) => a || b, false)
        }
      }

      allow = isOwner || isPartner
    }

    return allow
  }
}
